import './index.css'
import clsx from 'clsx'
import * as React from 'react'
import Heading from 'components/ui/heading'
type Props = {
  title?: string
  titleLeft?: string
  titleRight?: string
  separator?: boolean
  leftContent: React.ReactNode
  rightContent: React.ReactNode
  plainStyle?: boolean
}

/**
 * A row component with left and right content sections, optional titles, and separator styling
 *
 * @param title - Main title displayed above the row
 * @param titleLeft - Title for the left column
 * @param titleRight - Title for the right column
 * @param separator - Whether to show a separator line
 * @param leftContent - Content for the left column
 * @param rightContent - Content for the right column
 * @param plainStyle - Whether to use plain styling without background
 * @returns The action row component
 */
const ActionRow = ({
  title,
  titleLeft,
  titleRight,
  separator,
  leftContent,
  rightContent,
  plainStyle,
}: Props): React.ReactElement<'div'> => {
  return (
    <div
      className={clsx('Action-row', {
        'Action-row--separator': separator,
      })}
    >
      {title && (
        <div className="Action-row-title">
          <Heading size="500">{title}</Heading>
        </div>
      )}
      <div className="Action-row-columns">
        <div
          className={clsx('Action-row-left-column', {
            'Action-row-column--no-bg': plainStyle,
          })}
        >
          {titleLeft && <Heading size="600">{titleLeft}</Heading>}
          {leftContent}
        </div>
        <div
          className={clsx('Action-row-right-column', {
            'Action-row-column--no-bg': plainStyle,
          })}
        >
          {titleRight && <Heading size="600">{titleRight}</Heading>}
          {rightContent}
        </div>
      </div>
    </div>
  )
}

export default ActionRow
